export enum FlagType {
  AddCustomPropertyToDocxPdf = 'add-custom-property-to-docx-pdf-pilot-EKP-15897',
  AdvancedBulkClauseEditing = 'bulk-clause-editing-panel-ekp-19460',
  AribaControllerFlag = 'ariba-controller-flag',
  AribaFieldMappingCsvSupport = 'ariba-field-mapping-csv-support-ekp-23224',
  AribaMapEvisortDocumentURL = 'ekp-27330-ariba-map-evisort-url-field',
  AskAnything = 'ask-anything-ekp-23870',
  AskAnythingV3 = 'conversational-ai-v3-DST-3497',
  AskAnythingConversationHistory = 'ask-anything-conversation-history-EKP-24670',
  AskAnythingPreSig = 'ask-ai-in-pre-sig-ekp-24800',
  AskAnythingQuestionGroups = 'question-groups-ekp-24729',
  AskAiReportButton = 'ask-ai-show-copy-conversation-id-button-ekp-34330',
  BulkDeleteFieldValues = 'bulk-delete-field-values-ekp-16651',
  BulkEditFieldsRebuild = 'bulk-edit-fields-rebuild-ekp-23444',
  CCRecipients = 'ADD_CC_TO_ENVELOPE_EKP-12080',
  CheckFormFieldFileExtension = 'check-form-fields-uploaded-file-type-everest-ekp-14687',
  ClauseLibrary = 'clause-library-EKP-13390',
  ClauseLibraryAiSuggest = 'ai-suggest-mvp-ekp-16394',
  ClauseValueExportSettings = 'use-clause-value-for-export-settings-ekp-18340',
  ComponentMonitoringInSentry = 'enable-component-monitoring-in-sentry-ekp-23728',
  WorkflowContractType = 'wss-workflow-contract-type-ekp-41622',
  ConversationalAI = 'conversational-ai-ekp-18072',
  ConversationalAIV2 = 'conversational-ai-v2-EKP-24929',
  ConversationalAIButtonOnDocPageHeader = 'ask-ai-button-on-document-page-ekp-22487',
  CopyWorkflow = 'copy-workflow-ekp-26597',
  CustomAiHighlightMethod = 'x-ray-highlight-save-method-DST-3863',
  CustomAiModelDebug = 'internal-only-custom-ai-model-debug-page-ekp-45816',
  CustomAiPublishIroning = 'custom-ai-publish-ironing-ekp-34197',
  CustomAiSuperAdminRepublishing = 'custom-ai-republishing-ekp-45471',
  CustomAiTableExtraction = 'custom-ai-table-extraction-ekp-41551',
  CustomAiAsyncTestCreationExecution = 'custom-ai-async-test-creation-execution-ekp-44801',
  DashboardsExportExcel = 'dashboards-export-excel-ekp-14404',
  DashboardV3 = 'dashboards-v3-ekp-16349',
  DefaultDocumentEditor = 'default-document-editor-ekp-31853',
  DeprecateAnalyzer = 'deprecate-analyzer-ekp-27353',
  DeprecateEditProvision = 'deprecate-doc-viewer-edit-provision-ekp-25488',
  DeprecatePilotSearch = 'deprecate-pilot-search-ekp-25910',
  DevOnlyAgentForgeInvoke = 'dev-only-agentforge-invoke-ekp-ekp-43869',
  DisableDocumentTableSorting = 'disable-document-table-sorting-ekp-22199',
  DocumentsTableRevamp = 'documents-table-revamp-ekp-15821',
  DocumentDetailsInPostSig = 'document-details-panel-in-post-sig-ekp-29940',
  DocumentDetailsPanelUpdate = 'document-details-panel-update-ekp-47203',
  DocumentXRayBilling = 'document-x-ray-billing-EKP-21569',
  DocumentXRayCopilot = 'x-ray-copilot-ekp-33017',
  DocumentXRayDebugOutput = `document-x-ray-enable-llm-output-EKP-21757`,
  DocumentXRayHideModelLibraryVersions = 'xray-hide-model-library-versioning-ekp-32469',
  DocumentXrayNewPricingModel = 'x-ray-new-pricing-model-ekp-29738',
  DocumentXrayOptimize = 'document-x-ray-optimize-ekp-23418',
  DocumentXRayPrebuiltModels = 'x-ray-prebuilt-models-ekp-29135',
  DocumentXRayPrebuiltModelsAdmin = 'x-ray-prebuilt-models-admin-ekp-29684',
  DocumentXRayUnratedBoost = 'document-x-ray-allow-unrated-boost-ekp-23418',
  DocumentsBulkActionsOnSidepanel = 'display-document-bulk-actions-on-sidepanel-ekp-21793',
  DocuSignSignWithEmail = 'ekp-31142-docusign-remove-captive-signer',
  DashboardV2DocumentsBulkActions = 'dashboard-v2-document-bulk-actions-ekp-20467',
  DownloadDocumentAttachment = 'download-document-attachment-ekp-27325',
  CanduScript = 'candu-script-ekp-24642',
  EditFieldInDocumentDetailsPanel = 'edit-field-in-document-details-panel-ekp-14850',
  EsignatureBundle = 'e-signature-bundle-ekp-41302',
  EsignatureV2Revamp = 'esignature-2-revamp-ekp-29771',
  EnableWebhooksComponents = 'enable-webhooks-components-ekp-27770',
  FieldAi = 'field-ai-ekp-18695',
  FieldValueMigrationDeferredFeaturesBypass = 'fv-migration-deferred-features-bypass-EKP-15541',
  FilterChipApplyButton = 'filter-chip-apply-button-ekp-24057',
  FolderAccessSettings = 'folder-access-settings-ekp-27990',
  GenAi = 'generative-ai-m1-ekp-15067',
  GenAiM2 = 'generative-ai-m2-ekp-14984',
  GenAiRedline = 'generative-ai-m1.5-ekp-15067',
  HideAwsS3SyncPairOption = 'EKP-25969-hide-aws-s-3-sync-pair',
  HideClauseAffordance = 'hide-clause-affordance-ekp-29816',
  HideDocumentStatus = 'hide-document-status-ekp-18469',
  HideLegacyMultiSelectShowMore = 'hide-legacy-multi-select-show-more-EKP-9594',
  HideShareButton = 'disable-share-document-button-ekp-18915',
  IntakeFormEDSComponents = 'intake-form-eds-components-ekp-31967',
  IntakeFormFieldWithReadOnly = 'intake-form-field-with-read-only-fields-ekp-24165',
  DocumentOverviewEditFormEDSComponents = 'document-overview-edit-form-eds-components',
  LanguageSelect = 'language-select-ekp-31743',
  L1Languages = 'l1-languages-ekp-49972',
  LdPoc = 'LDPOC-UI-EKP-12166',
  ManagedEntities = 'managed-entities-ekp-28298',
  MicrosoftSharepointEmbedded = 'microsoft-sharepoint-embedded-ekp-31695',
  ModalConsolidation = 'modal-consolidation-ekp-46072',
  MultiDocWorkflowSupportAppendDocumentToContract = 'multi-doc-workflow-support-append-a-document-to-the-contract-ekp-31079',
  MultipleSfdcMigrationToEvi2ken = 'multiple-sfdc-migration-to-evi2ken-EKP-31518',
  NewIntegrationsPage = 'new-integrations-page-ekp-29665',
  NewQueryFiltersUI = 'new-query-filters-ui-ekp-30998',
  NewUsersPage = 'new-user-interface-ekp-16941',
  Onboarding = 'bento-onboarding-ekp-20003',
  Playbooks = 'playbooks-ekp-30524',
  PlaybookDraftPublish = 'playbook-draft-publish-EKP-47210',
  PlaybookReviewFeedback = 'playbook-review-feedback-ekp-45859',
  PlaybookTemplates = 'playbook-templates-EKP-47211',
  PersistedTableDebounce = 'persisted-table-debounce-ekp-45648',
  PremiumPermissions = 'premium-permissions-ekp-19952',
  PremiumAdministration = 'premium-administration-ekp-20639',
  QueryBuilderEnabled = 'query-builder-enabled-ekp-32439',
  QuickAiFilters = 'quick-ai-filters-EKP-26523',
  QuickAiTableSorting = 'Quick-AI-table-sorting-EKP-13386',
  QueryFiltersIntoSearchAndDashboard = 'query-filters-into-search-dashboard-ekp-32858',
  Rebrand = 'brand-transformation-phase-1-EKP-13212',
  RestorationHub500PageSize = 'restoration-hub-500-page-size-ekp-15159',
  ReactivateUsersEmailNotification = 'reactivate-user-email-notification-ekp-18548',
  ReplaceProvisionWithClause = 'replace-provision-with-clause-ekp-43636',
  RolodexAsUserDataSource = 'send-kafka-event-for-rolodex-user-changes-ekp-25303',
  SamlEnforceV2 = 'ENFORCE-SSO-FOR-ADMINS-AEGIS-EKP-12904',
  SearchV3 = 'search-v3-ekp-21526',
  SearchAsHomePage = 'search-as-home-page-EKP-14947',
  SearchPageResultsForAnalyzer = 'search-page-results-for-analyzer-ui-EKP-14679',
  SharepointSyncSiteSearch = 'sharepoint-sync-site-search-ui-EKP-13316',
  SharepointWizard = 'sharepoint-wizard-ekp-40591',
  ShareQuestionGroup = 'share-question-group-ekp-23010',
  ShowHeaderForFullscreenModals = 'show-header-for-fullscreen-modals-ekp-32497',
  SkipEmptyFolders = 'skip-empty-folders-ui-EKP-13941',
  SuperAdminSamlSSO = 'super-admin-saml-sso-EKP-21264',
  SuperAdminCreateWorkdayTenant = 'super-admin-can-create-workday-tenant-ekp-29471',
  SupportMultipleSFDCOrganizations = 'support-multiple-sfdc-organizations-to-1-evisort-client-EKP-15844',
  SyncConfiguration = 'sync-configuration-ekp-22664',
  StorageConfiguration = 'storage-configuration-ekp-32115',
  TextDelimitedMultiselectFilter = 'multiselect-filter-copy-paste-view-ekp-9715',
  TicketEmailActionWithComment = 'EMAIL-ACTIONS-COMMENT-EVEREST-EKP-14013',
  GroupedTicketsAndDocs = 'ticket-groups-ekp-32718',
  GroupedTicketsAndDocsM2 = 'tickets-and-docs-ekp-32724',
  TicketNaming = 'TICKET-NAMING-EVEREST-EKP-9884',
  Tracing = 'tracing-ui-EKP-12259',
  UnifiedDocumentDetailsPanel = 'document-table-details-panel-ekp-20186',
  UnifyDocumentViewer = 'unify-pdf-document-viewer-ekp-25127',
  UniversalNavHeader = 'universal-nav-header-ekp-32327',
  UploadPageNew = 'revamp-upload-page-ekp-20203',
  Webhooks = 'webhooks-ekp-27768',
  WordEditingOnlineWorkflow = 'word-online-editing-workflow-EKP-20133',
  WSSDesignatedWorkflow = 'wss-designated-workflow-ekp-29829',
  WSSIntegrationM2Amendments = 'wss-integration-m-2-amendments-ekp-41091',
  WSSIntegrationPhase2M1M3 = 'wss-integration-phase-2-m-1-m-3',
  WSSIntegrationWorkflowBuilderIntegrationTypeSelector = 'wss-integration-integration-type-ekp-47373',
  FolderContentPrefetch = 'folder-content-prefetch-EKP-33732',
  SupportAddingCustomerBillingId = 'support-adding-customer-billing-id-in-super-admin-panel-ekp-41719',
  RefactoredInformationField = 'refactored-information-field-ekp-41213',
  SuperAdminUserManagementAndAuthProvider = 'super-admin-user-management-and-auth-provider-ekp-42787',
  WorkflowRoutingAgent = 'workflow-routing-agent-epk-32903',
  NewConversationButtonInASKAIHeader = 'new-conversation-button-in-askai-header-ekp-45033',
  CLMEvolutionPhase1 = 'clm-evolution-phase-1-ekp-40675',
  WSSIntegrationM4SupplierNegotiation = 'wss-integration-m-4-supplier-negotiation-ekp-40919',
  WSSIntegrationM6ProcurementMigration = 'wss-integration-m-6-procurement-migration-ekp-41111',
  UseLocalStorageCache = 'use-cached-permissions-ekp-46326',
  TenantConnectivityTest = 'tenant-connectivity-test-ekp-45418',
}

export const flags = {
  [FlagType.AddCustomPropertyToDocxPdf]: false,
  [FlagType.AdvancedBulkClauseEditing]: true,
  [FlagType.AribaFieldMappingCsvSupport]: true,
  [FlagType.AribaMapEvisortDocumentURL]: true,
  [FlagType.AribaControllerFlag]: true,
  [FlagType.AskAnything]: true,
  [FlagType.AskAnythingV3]: true,
  [FlagType.AskAnythingConversationHistory]: true,
  [FlagType.AskAnythingPreSig]: true,
  [FlagType.AskAnythingQuestionGroups]: true,
  [FlagType.AskAiReportButton]: true,
  [FlagType.BulkDeleteFieldValues]: false,
  [FlagType.BulkEditFieldsRebuild]: true,
  [FlagType.CanduScript]: false,
  [FlagType.CCRecipients]: true,
  [FlagType.CheckFormFieldFileExtension]: true,
  [FlagType.ClauseLibrary]: true,
  [FlagType.ClauseLibraryAiSuggest]: false,
  [FlagType.ClauseValueExportSettings]: false,
  [FlagType.CLMEvolutionPhase1]: true,
  [FlagType.ComponentMonitoringInSentry]: false,
  [FlagType.WorkflowContractType]: true,
  [FlagType.ConversationalAI]: true,
  [FlagType.ConversationalAIV2]: true,
  [FlagType.ConversationalAIButtonOnDocPageHeader]: true,
  [FlagType.CopyWorkflow]: true,
  [FlagType.CustomAiHighlightMethod]: 'context_first',
  [FlagType.CustomAiModelDebug]: true,
  [FlagType.CustomAiPublishIroning]: true,
  [FlagType.CustomAiSuperAdminRepublishing]: false,
  [FlagType.CustomAiTableExtraction]: true,
  [FlagType.CustomAiAsyncTestCreationExecution]: true,
  [FlagType.DashboardsExportExcel]: true,
  [FlagType.DashboardV3]: true,
  [FlagType.DefaultDocumentEditor]: 'evisort',
  [FlagType.EsignatureBundle]: true,
  [FlagType.DeprecateAnalyzer]: false,
  [FlagType.DeprecateEditProvision]: false,
  [FlagType.DeprecatePilotSearch]: false,
  [FlagType.DevOnlyAgentForgeInvoke]: true,
  [FlagType.DisableDocumentTableSorting]: false,
  [FlagType.DocumentDetailsInPostSig]: true,
  [FlagType.DocumentDetailsPanelUpdate]: true,
  [FlagType.DocumentsTableRevamp]: true,
  [FlagType.DocumentXRayBilling]: true,
  [FlagType.DocumentXRayCopilot]: false,
  [FlagType.DocumentXRayDebugOutput]: false,
  [FlagType.DocumentXRayHideModelLibraryVersions]: false,
  [FlagType.DocumentXrayNewPricingModel]: true,
  [FlagType.DocumentXrayOptimize]: true,
  [FlagType.DocumentXRayPrebuiltModels]: true,
  [FlagType.DocumentXRayPrebuiltModelsAdmin]: false,
  [FlagType.DocumentXRayUnratedBoost]: true,
  [FlagType.DocumentsBulkActionsOnSidepanel]: true,
  [FlagType.DocuSignSignWithEmail]: false,
  [FlagType.DashboardV2DocumentsBulkActions]: true,
  [FlagType.DownloadDocumentAttachment]: true,
  [FlagType.EnableWebhooksComponents]: false,
  [FlagType.EditFieldInDocumentDetailsPanel]: true,
  [FlagType.EsignatureV2Revamp]: true,
  [FlagType.FieldAi]: true,
  [FlagType.FieldValueMigrationDeferredFeaturesBypass]: false,
  [FlagType.FilterChipApplyButton]: true,
  [FlagType.FolderAccessSettings]: true,
  [FlagType.GenAi]: true,
  [FlagType.GenAiM2]: true,
  [FlagType.GenAiRedline]: true,
  [FlagType.HideAwsS3SyncPairOption]: true,
  [FlagType.HideClauseAffordance]: false,
  [FlagType.HideDocumentStatus]: false,
  [FlagType.HideLegacyMultiSelectShowMore]: false,
  [FlagType.HideShareButton]: false,
  [FlagType.IntakeFormEDSComponents]: true,
  [FlagType.IntakeFormFieldWithReadOnly]: true,
  [FlagType.DocumentOverviewEditFormEDSComponents]: true,
  [FlagType.LanguageSelect]: true,
  [FlagType.L1Languages]: true,
  [FlagType.LdPoc]: true,
  [FlagType.ManagedEntities]: false,
  [FlagType.MicrosoftSharepointEmbedded]: true,
  [FlagType.ModalConsolidation]: true,
  [FlagType.MultiDocWorkflowSupportAppendDocumentToContract]: false,
  [FlagType.MultipleSfdcMigrationToEvi2ken]: false,
  [FlagType.NewIntegrationsPage]: false,
  [FlagType.NewQueryFiltersUI]: true,
  [FlagType.NewUsersPage]: true,
  [FlagType.Onboarding]: false,
  [FlagType.Playbooks]: true,
  [FlagType.PlaybookDraftPublish]: true,
  [FlagType.PlaybookReviewFeedback]: true,
  [FlagType.PlaybookTemplates]: true,
  [FlagType.PremiumPermissions]: true,
  [FlagType.PremiumAdministration]: true,
  [FlagType.QueryBuilderEnabled]: true,
  [FlagType.QueryFiltersIntoSearchAndDashboard]: true,
  [FlagType.QuickAiFilters]: true,
  [FlagType.QuickAiTableSorting]: false,
  [FlagType.ReactivateUsersEmailNotification]: true,
  [FlagType.Rebrand]: true,
  [FlagType.PersistedTableDebounce]: true,
  [FlagType.ReplaceProvisionWithClause]: true,
  [FlagType.RestorationHub500PageSize]: false,
  [FlagType.RolodexAsUserDataSource]: true,
  [FlagType.SamlEnforceV2]: true,
  [FlagType.SearchV3]: true,
  [FlagType.SearchAsHomePage]: false,
  [FlagType.SearchPageResultsForAnalyzer]: false,
  [FlagType.SharepointSyncSiteSearch]: true,
  [FlagType.SharepointWizard]: true,
  [FlagType.ShareQuestionGroup]: false,
  [FlagType.ShowHeaderForFullscreenModals]: false,
  [FlagType.SkipEmptyFolders]: true,
  [FlagType.SuperAdminSamlSSO]: true,
  [FlagType.SuperAdminCreateWorkdayTenant]: true,
  [FlagType.SupportMultipleSFDCOrganizations]: true,
  [FlagType.SyncConfiguration]: true,
  [FlagType.StorageConfiguration]: true,
  [FlagType.TextDelimitedMultiselectFilter]: true,
  [FlagType.TicketEmailActionWithComment]: false,
  [FlagType.GroupedTicketsAndDocs]: true,
  [FlagType.GroupedTicketsAndDocsM2]: true,
  [FlagType.TicketNaming]: true,
  [FlagType.Tracing]: false,
  [FlagType.UnifiedDocumentDetailsPanel]: true,
  [FlagType.UnifyDocumentViewer]: true,
  [FlagType.UniversalNavHeader]: false,
  [FlagType.UploadPageNew]: false,
  [FlagType.Webhooks]: true,
  [FlagType.WordEditingOnlineWorkflow]: true,
  [FlagType.WSSDesignatedWorkflow]: true,
  [FlagType.WSSIntegrationM2Amendments]: true,
  [FlagType.WSSIntegrationPhase2M1M3]: true,
  [FlagType.FolderContentPrefetch]: true,
  [FlagType.SupportAddingCustomerBillingId]: true,
  [FlagType.RefactoredInformationField]: true,
  [FlagType.SuperAdminUserManagementAndAuthProvider]: false,
  [FlagType.WorkflowRoutingAgent]: true,
  [FlagType.NewConversationButtonInASKAIHeader]: true,
  [FlagType.WSSIntegrationM4SupplierNegotiation]: true,
  [FlagType.WSSIntegrationM6ProcurementMigration]: false,
  [FlagType.UseLocalStorageCache]: true,
  [FlagType.TenantConnectivityTest]: true,
  [FlagType.WSSIntegrationWorkflowBuilderIntegrationTypeSelector]: true,
};
